import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Title from '@helsenorge/designsystem-react/components/Title';
import Favorites from './favorites';
import TjenestepanelContainer from './tjenestepanel-container';
import Tjenester from './tjenester';
import TjenesterList from './tjenester-list';
import TjenesterTiles from './tjenester-tiles';
import styles from './styles.module.scss';
const hasValidFavorites = (favorites) => !!favorites && favorites.length > 0 && !!favorites[0] && Array.isArray(favorites[0].tiles) && favorites[0].tiles.length > 0;
const hasValidGroups = (groups) => !!groups && groups.length > 0;
const Tjenestepanel = (props) => {
    if (!hasValidFavorites(props.favorites) && !hasValidGroups(props.groups)) {
        return null;
    }
    const title = props.favorites && props.favorites[0] && props.favorites[0].title;
    return (_jsxs(TjenestepanelContainer, { children: [title && (_jsx(Title, { htmlMarkup: 'h1', id: props.titleId, className: styles.tjenestepanel__title, children: title })), hasValidFavorites(props.favorites) && _jsx(Favorites, { favorites: props.favorites[0].tiles, sharingStatusText: props.sharingStatusText }), hasValidGroups(props.groups) && (_jsx(Tjenester, { tiles: _jsx(TjenesterTiles, { groups: props.groups, sharingStatusText: props.sharingStatusText }), list: _jsx(TjenesterList, { groups: props.groups, sharingStatusText: props.sharingStatusText }), showMore: props.showMore, showLess: props.showLess, noToggle: !hasValidFavorites(props.favorites) }))] }));
};
export default Tjenestepanel;
